import styled from 'styled-components'

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Actions = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.sp16};

  div,
  button {
    height: ${props => props.theme.size.L};
  }
`
